import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/scss/sections/_header.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import RightArrow from '../../../assets/images/RightArrow.svg';
import { slide as Menu } from 'react-burger-menu';

const Header = ({ setting_data }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <section id="top_sub_header">
        <div>
          <Container>
            <Row className="sub_header g-0">
              <Col xs={12}>
                <div className="header_numbers">
                  <h6 className="aot_main_title">Arrive On Time Delivery</h6>
                  <ul>
                    <li>
                      <span className="custom-icon">
                        <FontAwesomeIcon icon={faPhone} />
                      </span>
                      <a> {setting_data?.home_page_header_number_1}</a>
                    </li>
                    <li>
                      <span className="custom-icon">
                        <FontAwesomeIcon icon={faPhone} />
                      </span>
                      <a>{setting_data?.home_page_header_number_2}</a>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <section id="main_header">
        <Menu
          className="header_menu"
          right
          pageWrapId={'page-wrap'}
          isOpen={isOpen}
          onOpen={() => {
            setOpen(!isOpen);
          }}>
          <span
            className="close_main_btn"
            onClick={() => {
              setOpen(!isOpen);
            }}></span>
          <div className="pop_logo">
            <a className="navbar-brand" href="#">
              <img className="Aotmainlogo" src={setting_data?.home_page_header_logo} />
            </a>
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item active">
                <a className="nav-link" href="#">
                  Home <span className="sr-only">(current)</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  Quote
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  Track
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <form className="form-inline">
            <a className="common_button overlay_btn_slide" type="submit">
              <span className="main_login_text"> Login </span>
              <img src={RightArrow} />
            </a>
          </form>
        </Menu>
        <Container>
          <Row>
            <Col xs={12}>
              <div className="close_icons"></div>
              <nav className="navbar navbar-expand-lg">
                <a className="navbar-brand" href="#">
                  <img className="Aotmainlogo" src={setting_data?.home_page_header_logo} />
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav mr-auto">
                    <li className="nav-item active">
                      <a className="nav-link" href="#">
                        Home <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Services
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        About
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Quote
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Track
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
                <form className="form-inline">
                  <a className="common_button" type="submit">
                    <span className="main_login_text"> Login </span> <img src={RightArrow} />
                  </a>
                </form>
              </nav>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
Header.propTypes = {
  setting_data: PropTypes.object,
};
export { Header };
